import React from 'react';
import PaidOfferings from './PaidOfferings';

const ChooseProgram = ({ categoryId }: { categoryId: string }) => {
  return <PaidOfferings categoryId={categoryId} />;
};

export default ChooseProgram;
